import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import '../../assets/stylesheets/shared/_tippy.scss'

document.addEventListener('turbolinks:load', () => {
  tippy('[data-tippy-content]', {
    theme: 'dmarc',
    allowHTML: true,
  })
})

document.addEventListener('ajax:complete', () => {
  tippy('[data-tippy-content]', {
    theme: 'dmarc',
    allowHTML: true,
  })
})
